import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { DataEndpoint } from '@core/models/general.model';
import { Observable, map } from 'rxjs';
import { EmissionsFactory, EmissionsFactoryPaginatedModel, EmissionsFactoryRequestModel, EmissionsSourcesFactoryPaginatedModel } from '../models/emissions-factory.model';
import { HttpUtils } from '@core/utils/http.utils';

@Injectable({
    providedIn: 'root',
})

export class EmissionsSourcesApi {

    private readonly http = inject(HttpClient)

    private readonly EMISSION_SOURCES = '/EmissionSource'
    private readonly SOURCES = '/Sources'

    getEmissionsSourcesByBusiness(request: EmissionsFactoryRequestModel): Observable<DataEndpoint<EmissionsSourcesFactoryPaginatedModel>> {
        const url = this.EMISSION_SOURCES;
        const params = HttpUtils.objectToHttpParams(request);

        return this.http.get<DataEndpoint<EmissionsSourcesFactoryPaginatedModel>>(url, { params })
            .pipe(map((data: DataEndpoint<EmissionsSourcesFactoryPaginatedModel>) => {
                return { ...data }
            }));
    }

    // emissions-sources-api.ts
    saveEmissionsSources(body: {
        CompanyId: string;
        OfficeId: string;
        AddedSourceIds: string[];
        RemovedSourceIds: string[];
    }) {
        const url = this.SOURCES;
        return this.http.put<DataEndpoint<any>>(
            `${url}/assign`, 
            body
        );
    }

}